module.exports = __webpack_public_path__ + "img/ELECTRIC-COMPONENTS.5ef2e849.jpg";